"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  alignItems: 'center',
  color: theme.palette.text.primary,
  display: 'flex',
  gap: theme.spacing(1),
  a: {
    color: theme.palette.text.primary
  }
}));
